if (!customElements.get('infinite-scroll')) {
  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();

      this.searchParams = new URLSearchParams(location.search);

      this.previousUrl = this.dataset.previousUrl;
      this.nextUrl = this.dataset.nextUrl;
      this.currentPage = this.dataset.currentPage;
      this.currentUrl = this.dataset.currentUrl;

      this.targetList = this.querySelector('ul');
      this.elementToObserve = this.querySelector('.infinite-scroll--observed');
      this.loadPrevious = this.querySelector('[data-load-previous]');
      this.loadNext = this.querySelector('[data-load-next]');
      this.loadPreviousButton = this.querySelector('[data-load-previous] .button');
      this.loadNextButton = this.querySelector('[data-load-next] .button');
      this.statusContainer = this.querySelector('.infinite-scroll--status');

      this.storedPage = this.searchParams.get('page');

      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      if (this.searchParams.get('page') && parseInt(this.searchParams.get('page')) > 1) {
        this.loadPrevious.classList.remove('hide');

        this.loadPrevious.querySelector('button').addEventListener('click', e => {
          e.preventDefault();

          this.handlePrevious();
        });
      }

      this.bindCardClickEvents();
    }

    connectedCallback() {
      if (this.loadNext) {
        this.loadNext.querySelector('button').addEventListener('click', e => {
          this.handleNext();
        });
      } else {
        if (this.elementToObserve) {
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;

            this.handleNext();
          };

          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this.elementToObserve);
        }
      }
    }

    loadingState(button, enable) {
      button.setAttribute('aria-disabled', enable);
      button.classList.toggle('loading', enable);
      button.querySelector('.loading-overlay__spinner').classList.toggle('hidden', !enable);
    }

    handlePrevious() {
      this.loadingState(this.loadPreviousButton, true);

      fetch(this.currentUrl + '?page=' + (this.storedPage - 1))
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");

          let docInfiniteScroll = doc.querySelector('infinite-scroll');

          if (docInfiniteScroll.dataset.currentPage == '1') {
            this.loadPrevious.classList.add('hide');
          }

          this.storedPage = this.storedPage - 1;

          if (this.storedPage != 1) {
            this.searchParams.set('page', this.storedPage);
          } else {
            this.searchParams.delete('page');
          }
          window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);

          if (this.targetList) {
            this.targetList.insertAdjacentHTML('afterbegin', docInfiniteScroll.querySelector('ul').innerHTML);
          }

          this.loadedCallback();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleNext() {
      if (this.nextUrl) {
        if (this.loadNextButton) {
          this.loadingState(this.loadNextButton, true);
        }

        console.log('handle next')

        fetch(this.nextUrl)
          .then((response) => response.text())
          .then((text) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");

            let docInfiniteScroll = doc.querySelector('infinite-scroll');

            this.previousUrl = docInfiniteScroll.dataset.previousUrl;
            this.nextUrl = docInfiniteScroll.dataset.nextUrl;
            this.currentPage = docInfiniteScroll.dataset.currentPage;

            if (this.currentPage != '1') {
              this.searchParams.set('page', this.currentPage);
            }

            window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);
            if (this.targetList)
              this.targetList.insertAdjacentHTML('beforeend', docInfiniteScroll.querySelector('ul').innerHTML);
            const docStatusContainer = docInfiniteScroll.querySelector('.infinite-scroll--status');
            if (this.statusContainer && docStatusContainer) {
              this.statusContainer.innerHTML = docStatusContainer.innerHTML;
            }

            if (!this.nextUrl) {
              this.loadNext.remove();
            }

            this.loadedCallback();
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }

    loadedCallback() {
      this.loadPreviousButton && this.loadingState(this.loadPreviousButton, false);
      this.loadNextButton && this.loadingState(this.loadNextButton, false);

      if (typeof loadReviewsIoRatingSnippets === 'function') {
        loadReviewsIoRatingSnippets();
      }

      if (typeof window.trustspot_init === 'function') {
        window.trustspot_init();
      }

      this.bindCardClickEvents();
    }

    bindCardClickEvents() {
      let cards = this.querySelectorAll('.product-grid li a');

      if (cards) {
        for (const card of cards) {
          card.addEventListener('click', e => {
            let link = e.target.href;
            let liItem = e.target.closest('li');

            if (liItem && liItem.dataset.currentPage) {
              e.preventDefault();

              let currentPage = liItem.dataset.currentPage;

              this.searchParams.set('page', currentPage);
  
              window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);

              window.location.href = link;
            }
          });
        }
      }
    }
  }

  customElements.define('infinite-scroll', InfiniteScroll);
}
